import { Typography, Grid, ListItem, List, ListItemText } from '@mui/material';

const SummaryList = ({ label = '', values = [] }) => {
  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography component="span" color="text.secondary">
            {label}:
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <List dense={true}>
            {values.map(({ primary, secondary }, index) => (
              <ListItem sx={{ display: 'block' }} key={`sl-index-${index}`}>
                <ListItemText primary={primary} secondary={secondary} />
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </>
  );
};

export default SummaryList;
